<script setup lang="ts">
import { AppStandardModal } from '@libs/ui';

import ActivityDetailsMainDescription from './ActivityDetailsMainDescription.vue';

interface FullDescriptionModalProps {
  mainDescription: string | undefined;
  activityName: string | undefined;
}
const props = defineProps<FullDescriptionModalProps>();

interface FullDescriptionModalEmits {
  (event: 'close-modal'): void;
}
const emit = defineEmits<FullDescriptionModalEmits>();
</script>

<template>
  <AppStandardModal
    :close-button-aria-label="$t('a11y.close_panel')"
    @close="emit('close-modal')"
  >
    <template #title>
      {{ activityName }}
    </template>
    <template #body>
      <ActivityDetailsMainDescription
        class="main-description"
        :main-description="props.mainDescription"
      />
    </template>
  </AppStandardModal>
</template>

<style scoped lang="scss">
.main-description {
  @include font-body-m-light;
}
</style>
